<template>
    <div :class="`a-progressBar --${type} --text-${textPosition} ${isSteps ? '--steps' : ''}`">
        <div
            v-for="(step, idx) in steps"
            :key="idx"
            class="a-progressBar__stepLabel"
            :class="{ active: isActiveStep(step.value) }"
            :style="`left: ${stepPercentage(step.value)}%`"
            v-tooltip="step.tooltip"
            v-text="step.value"
        />
        <div
            class="a-progressBar__bar"
            :style="isSteps
                ? { background: stepProgressBarStyle }
                : { width: `${progressBarWidth}%` }"
        ></div>
        <div v-if="isSteps" class="d-flex">
            <div
                v-for="(step, idx) in steps.slice(0, -1)"
                :key="idx"
                class="a-progressBar__step"
                :class="{ active: isActiveStep(step.value) }"
                :style="`left: ${stepPercentage(step.value)}%`"
            />
        </div>
        <div v-if="$slots.default || showLabel" class="a-progressBar__label">
            <slot v-if="$slots.default" />
            <span v-else>{{ progress }} / {{ limit }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        barWidth: {
            type: Number,
            required: false
        },
        progress: {
            type: Number,
            required: false
        },
        limit: {
            type: Number,
            required: false
        },
        showLabel: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'normal'
        },
        textPosition: {
            type: String,
            default: 'center'
        },
        steps: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        progressBarWidth() {
            if (this.barWidth) {
                return this.barWidth
            }
            const percentage = (this.progress / this.limit) * 100
            return percentage.toFixed()
        },
        isSteps() {
            return !!this.steps.length
        },
        stepProgressBarStyle() {
            const achievedStep = this.steps.map(v => v.value).findLast(step => this.isActiveStep(step)) || 0
            const achievedProgress = this.stepPercentage(achievedStep)
            const duringProgress = this.stepPercentage(this.progress)

            return `
                linear-gradient(
                    to right, var(--color-secondary) 0%, var(--color-secondary) ${achievedProgress}%,
                    rgba(107, 182, 69, 0.5) ${achievedProgress}%, rgba(107, 182, 69, 0.5) ${duringProgress}%,
                    #fff ${duringProgress}%, #fff 100%
                )
            `
        }
    },
    methods: {
        stepPercentage(value) {
            return (value / this.limit) * 100
        },
        isActiveStep(value) {
            return value <= this.progress
        }
    }
}
</script>
